// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"05985f3a","958":"3ecfd305"}[chunkId] + ".chunk.js";
};